module.exports = __webpack_public_path__ + "img/ic_emoji_sad.68cc8c08.png";